import { createFileRoute } from "@tanstack/react-router"
import { KeyMetricsPage } from "@/pages/key-metrics"

export const Route = createFileRoute("/(analytics)/key-metrics")({
	component: KeyMetricsPage,
})
